import React from 'react';
import {useNavigate} from "react-router-dom";
import Modalheader from "components/modal/components/header";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import {MISSION_FIRST_PAGE} from "pages/createMission/utils/missionSteps";


const CloseProcess = () => {
    const navigate = useNavigate()
    const {toggle} = useModal()
    const {setPage, setData, setMissionCostEstimate, setSelectedMissionTemplate} = UseContext()
    const handleClose = (e) => {
        e.preventDefault()
        setData({
            activity: '',
            qualification: '',
            tools: [],
            licences: [],
            languages: [],
            contact_name: '',
            contact_poste: '',
            location: '',
            dateStart: '',
            dateEnd: '',
            schedule: [],
            isScheduleCheck: true, // if the company choose to have a schedule
            isConfirmedSchedule: false, // if the company valid schedule with empty periods
            isScheduleRequired: false, // if the company have a 1 day mission
            users_invite: [],
            motif: '',
            other: '',
            other_interim: '',
            salary: ''
        })
        setMissionCostEstimate(0)
        setSelectedMissionTemplate(null)
        setPage(MISSION_FIRST_PAGE)
        toggle()
        navigate('/missions')
    }
    const handleReturn=(e)=>{
        e.preventDefault()
        toggle()
    }

    return (
        <>
            <Modalheader
                hide={handleReturn}
                hideShow={true}
                icon="warning"
                description="Êtes-vous sûr de vouloir quitter la page ? Vos modifications ne seront pas enregistrées."
            >
                Quitter la création de mission
            </Modalheader>
            {/*footer*/}
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'}
                        onClick={handleReturn}>Annuler</Button>
                <Button size={'LG'}
                        onClick={handleClose}>Confirmer</Button>
            </ModalFooter>

        </>
    );
};

export default CloseProcess;